import { instance } from "libs/api";

import { ApiRoutesDeliveryCompanies } from "../../constants";
import {
  GetDeliveryCompaniesRequestParams,
  GetDeliveryCompaniesResponse
} from "./getDeliveryCompanies.types";

export const requestGetDeliveryCompanies = async (
  params: GetDeliveryCompaniesRequestParams
): Promise<GetDeliveryCompaniesResponse> => {
  return await instance.get(ApiRoutesDeliveryCompanies.CompaniesAll, {
    params
  });
};
